// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentNews_container__1w3Lo","title":"RecentNews_title__2abcG","content":"RecentNews_content__3edCp"};